import React__default from 'react';
import PropTypes from 'prop-types';
import { a as createCommonjsModule } from './_commonjsHelpers-17042db9.js';

var classnames = createCommonjsModule(function (module) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function Icon(props) {
  var name = props.name,
    className = props.className,
    disabled = props.disabled,
    onClick = props.onClick;
  var size = props.size;
  var allowedSizes = ['small', 'normal', 'medium', 'large', 'xlarge', 'huge', 'extra'];
  size = allowedSizes.some(function (validSize) {
    return validSize === size;
  }) ? "bf-icon-size-".concat(size) : '';
  var classes = classnames("bf-icon ".concat(name), size, {
    'bf-text-muted': disabled
  }, "".concat(className));
  return /*#__PURE__*/React__default.createElement("span", {
    className: classes,
    onClick: onClick
  });
}
Icon.defaultProps = {
  className: '',
  size: 'normal',
  disabled: false,
  onClick: function onClick() {}
};
Icon.propTypes = {
  /**
  Icon name
   */
  name: PropTypes.string.isRequired,
  /**
  Icon size
   */
  size: PropTypes.string,
  /**
  Icon disabled
   */
  disabled: PropTypes.bool,
  /**
  Custom className
   */
  className: PropTypes.string,
  onClick: PropTypes.func
};

export { Icon as I, classnames as c };
//# sourceMappingURL=index-11bc5ac3.js.map
